import React, { useState, useEffect, Fragment } from "react";
import {TextField, CircularProgress, Avatar} from "@material-ui/core";
import {Autocomplete} from '@material-ui/lab';
import { useHistory } from "react-router-dom";
import useStyles from './styles'
import ttAPI from '../../api/ttAPI'
import parse from 'autosuggest-highlight/parse';
import match from 'autosuggest-highlight/match';

import config from '../../config'


export default function SelectAccount(props) {
  const { onSelect, labelName } = props
  const classes = useStyles();
  const history = useHistory();
  const [accountSearchedList, setAccountSearchedList] = useState([]);
  const [selectedAccountValue, setSelectedAccountValue] = useState({});
  const [accountInputValue, setAccountInputValue] = useState('');
  const [isSearchAccountOpen, setIsSearchAccountOpen] = useState(false);

  useEffect( () => {
    async function fetchData() {
      const response = await ttAPI.getAllAccountsByKey(accountInputValue);
      setAccountSearchedList(response === null ? [] : response);
    }
    if (accountInputValue !== undefined && accountInputValue !== '' && accountInputValue.length >= 3) {
      fetchData();
    }
  }, [accountInputValue]);


  useEffect(() => {
    if (!isSearchAccountOpen) {
      setAccountSearchedList([]);
    }
  }, [setAccountSearchedList]);

  const getAvatar = (id) => {
    return (<Avatar src={`${config.hostApi}${config.portApi ? `:${config.portApi}` : ``}/client/aimages/${id}`}/>);
  }


   // note: for getOptionSelected: if you return false for no match then there will be a warning in the console complain the input does not match what's in the options}
  return (
<div className={classes.contentDiv}>
    <Autocomplete
      id="search-retest"
      className={classes.autocomplete}
      ListboxProps={{ style: { top: '0px', maxHeight: "calc(40vh)"}, position: "bottom-start" }}
      getOptionSelected={(option, value) => {
        if (value === '') {
          return true;
        }
        return Object.keys(option).length === 0 || Object.keys(value).length === 0 ? true : option.name === value.name;}
      }
      getOptionLabel={(option) => {
        if (option === null || option === undefined || option == '') {
          return '';
        }
        return Object.keys(option).length === 0 ? '' : `${option.name} - ${option.signon}`;
      }}
      renderOption={(option, state) => {
        if (option === null || option === undefined || option == '') {
          return '';
        }

        const matches = match(option.name, accountInputValue);
        const parts = parse(option.name, matches);

        const matchesSignon = match(option.signon, accountInputValue);
        const partsSignon = parse(option.signon, matchesSignon);

        return (
        <Fragment key={option.id}>
          <div className={classes.option}>
            <span className={classes.optionSpan}>
              {getAvatar(`${option.id}`)}
            </span>
            <span className={classes.optionSpan}>
            {parts.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
            <span className={classes.optionSpan}>
            {partsSignon.map((part, index) => (
              <span key={index} style={{ fontWeight: part.highlight ? 700 : 400 }}>
                {part.text}
              </span>
            ))}
            </span>
          </div>
        </Fragment>
      );
      }}
      filterOptions={(options, state) => {/*need to keep this function here for phrase matching*/ return options;}}
      options={accountSearchedList}
      noOptionsText="No Result"
      onChange={(event, newValue) => {
        if (newValue !== undefined && newValue !== null) {
          setSelectedAccountValue(newValue);
          onSelect(newValue);
        }
        else {
          setSelectedAccountValue('');
          onSelect(undefined);
        }

      }}
      open={isSearchAccountOpen}
      onOpen={() => {
        setIsSearchAccountOpen(true);
      }}
      onClose={() => {
        setIsSearchAccountOpen(false);
      }}
      inputValue={accountInputValue}
      value={selectedAccountValue}
      onInputChange={(event, newInputValue,reason) => {
          setAccountInputValue(newInputValue);
      }}
      size="small"
      renderInput={(params) => <TextField
                                {...params}
                                style={{ backgroundColor: 'white' }}
                                placeholder={labelName}
                                variant="outlined"
                                  />}
      />
      </div>
  );
}
